module.exports = __webpack_public_path__ + "img/dj.8db320c1.png";